import { useEffect } from 'react';
import { decodeUrlParam, encodeUrlParam } from '@warehouse/shared/util';

/**
 * @deprecated Bypasses React Router (not reactive). Use `useStateQuery` (@warehouse/shared/util) for
 * simple URL-backed state, or `definePersistentQueryParamStore` for a store mirrored in the URL.
 */
export function getURLQuery() {
	return new URLSearchParams(window.location.search);
}

function queryParamsToString(query: URLSearchParams) {
	return query.size > 0 ? `?${query.toString()}` : '';
}

/** @deprecated Use `useStateQuery` (@warehouse/shared/util) instead. */
export const setQuery = (label: string, encoded: string) => {
	const query = getURLQuery();

	query.set(label, encoded);
	window.history.replaceState(
		{},
		'',
		`${window.location.pathname}${queryParamsToString(query)}${window.location.hash}`,
	);
};

/** @deprecated Use `useStateQuery` (@warehouse/shared/util) instead. */
export const deleteQuery = (label: string) => {
	const query = getURLQuery();

	query.delete(label);
	window.history.replaceState(
		window.history.state,
		'',
		`${window.location.pathname}${queryParamsToString(query)}${window.location.hash}`,
	);
};

/** @deprecated Use `useStateQuery` (@warehouse/shared/util) instead. */
export const useStateToURLSync = <T>(value: T, initialState: T, urlKey: string) => {
	useEffect(() => {
		if (JSON.stringify(value) !== JSON.stringify(initialState)) {
			setQuery(urlKey, encodeUrlParam(value));
		} else deleteQuery(urlKey);
	}, [value]);
};

/** @deprecated Use `useStateQuery` (@warehouse/shared/util) instead. */
export const useURLToStateSync = <T>(urlKey: string, callbackFn: (value: T | undefined) => void) => {
	useEffect(() => {
		const query = getURLQuery();

		const urlValue = query.get(urlKey);
		if (urlValue) {
			try {
				callbackFn(decodeUrlParam<T>(urlValue));
			} catch (err) {
				callbackFn(undefined);
			}
		}
	}, []);
};
